<table class="layout-fixed title" cellpadding="0" cellspacing="0" frame="void" rules="none">
  <colgroup>
    <col class="width-33" />
    <col class="width-33" />
    <col class="width-33" />
  </colgroup>
  <thead [ngClass]="{'display-none' : isTableHeadEmpty}">
    <tr>
      <th colspan="3">
        <div class="logoWrapper">
          <img class="headerLogo" offline-logo src="" alt="" />
          <img
            class="headerLogo"
            appOfflineLogo
            [base64EncodedLogoContent]="projectSetup.subprojectConfiguration?.base64EncodedLogoContent"
            src=""
            alt=""
          />
        </div>
        <div class="print-header">
          <h1>{{reportLabel}}</h1>
          <h2>{{subprojectName}}</h2>
        </div>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        <label i18n="@@report.reportHeader.lblDprNumber">DPR Number</label>
        <span>{{dprDetails.dprDisplayId}}</span>
      </td>
      <td>
        <label i18n="@@report.reportHeader.lblDate">Date</label>
        <span>{{dprDate | date : "dd/MM/y" }} 00:00-24:00</span>
      </td>
      <td>
        <label i18n="@@report.reportHeader.lblRevision">Revision</label>
        <span>{{dprDetails.revision}}</span>
      </td>
    </tr>
    <tr [ngClass]="{'display-none' : isRowEmpty}">
      <td>
        <label>{{projectLabel}}</label>
        <span>{{projectNameValue}}</span>
      </td>
      <td>
        <label>{{clientLabel}}</label>
        <span>{{clientNameValue}}</span>
      </td>
      <td>
        <ng-container *ngIf="shouldDisplayApprovalStatusSummary; else noApproversSection">
          <label i18n="@@report.reportHeader.lblApprovalStatusSummary">Approval Status Summary</label>
          <table class="noBorder status-summary">
            <tr>
              <td *ngFor="let item of approvalStatusSummary">
                <span>
                  <mat-icon
                    [class]="'icon--' + (item | approveStatusColor : 'approveStatus')"
                    class="icon-position mr-1"
                    [svgIcon]="item | approveStatusIcon : 'approveStatus'"
                  ></mat-icon>
                  <span>
                    {{item | approveStatusText : projectSetup.subprojectConfiguration.customNames : 'approveStatus'}}
                  </span>
                  <span class="print-badge">{{item.approveStatusCount ?? 0}}</span>
                </span>
              </td>
            </tr>
          </table>
        </ng-container>

        <ng-template #noApproversSection>
          <label>{{onlineApproversLabel}}</label>
          <span>{{onlineApproversStatus}}</span>
        </ng-template>
      </td>
    </tr>
  </tbody>
</table>
